import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink } from 'react-router-dom';
import config from '../../config';
import {getLogout,roleid} from '../Actions/AuthAction';
import AdminSidebar from '../Common/AdminSidebar';
import RecruiterSidebar from '../Common/RecruiterSidebar';
import EmployerSidebar from '../Common/EmployerSidebar';
import CandidateSidebar from '../Common/CandidateSidebar';
import InstituteSidebar from '../Common/InstituteSidebar';
import UniversitySidebar from '../Common/UniversitySidebar';
import CompanySidebar from '../Common/InstituteSidebar';
import LeadSideBar from './LeadSideBar';



const LeftSidebar = (props) => {

    const logout = (e) => {
        //alert("fsdf");
        getLogout(props);
    }

  
        return (
            <React.Fragment>
			
			 {roleid() && roleid() == 1 ? <AdminSidebar /> 
				: roleid() && roleid() == 2 ? <InstituteSidebar /> 
				: roleid() && roleid() == 3 ? <RecruiterSidebar />
                : roleid() && roleid() == 4 ? <EmployerSidebar /> 
				: roleid() && roleid() == 5 ? <CandidateSidebar />
                : roleid() && roleid() == 6 ? <UniversitySidebar />
                : roleid() && roleid() == 7 ? <CompanySidebar /> 
                : roleid() && roleid() == 8 ? <LeadSideBar />:
                
                <span></span>}
		</React.Fragment>
    )
    
}
export default LeftSidebar
